import React, { useState } from 'react';
import {
    TableRow,
    TableCell,
    Typography
} from '@mui/material';
import { useDispatch } from 'react-redux';
import ActionButtons from '../../dashboard/actionButtons';
import EditTextField from '../../../overrides/editField';
import { saveCafeteriaWatcher, deleteCafeteriaWatcher } from '../../../../redux/actionCreators/admin/cafeteria';

const CafeteriaTableRow = ({ rowData }) => {
    const dispatch = useDispatch();

    const [status, setStatus] = useState('list');
    const [editData, setEditData] = useState({});
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)

    const handleEditChange = (e) => {
        const { name, value } = e.target
        setEditData({ ...editData, [name]: value })
    }

    const handleEdit = () => {
        setEditData({ ...rowData });
        setStatus('edit');
    }

    const handleDelete = async () => {
        await dispatch(deleteCafeteriaWatcher(rowData.nID))
        setStatus('list');
        setDeleteDialogOpen(false);
    }

    const tickIconFunction = async () => {
        if (!`${editData.Cafeteria || ''}`.trim()) return

        // The saga calls this only after a successful save (e.g. not on a duplicate name)
        dispatch(saveCafeteriaWatcher({
            ACTION: 'UPDATE',
            NID: rowData.nID,
            CAFETERIA: editData.Cafeteria
        }, () => setStatus('list')));
    }

    const cancelIconFunction = () => {
        setEditData({});
        setStatus('list');
    }

    return (
        <TableRow hover tabIndex={-1}>
            <TableCell align="left">
                <Typography variant='t14_600'>
                    {rowData.nID}
                </Typography>
            </TableCell>

            <TableCell align="left">
                {status === 'list'
                    ? <Typography variant='t14_600'>{rowData.Cafeteria}</Typography>
                    : <EditTextField
                        name='Cafeteria'
                        value={editData.Cafeteria || ''}
                        onChange={handleEditChange}
                    />
                }
            </TableCell>

            <TableCell align="right">
                <ActionButtons
                    status={status}
                    setStatus={setStatus}
                    type={'cafeteria'}
                    tickIconFunction={tickIconFunction}
                    handleDelete={handleDelete}
                    handleEdit={handleEdit}
                    cancelIconFunction={cancelIconFunction}
                    setDeleteDialogOpen={setDeleteDialogOpen}
                    deleteDialogOpen={deleteDialogOpen}
                />
            </TableCell>
        </TableRow>
    )
}

export default CafeteriaTableRow
